export default __webpack_public_path__ + "static/media/banner-03.6d32ce94.webp";